export default "__VITE_ASSET__74229207__"